import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface FiscalRule {
  id?: string
  name: string
  code: string
  countryId?: string
  country_id: string
  regime_type?: number
  payment_type?: string
  hour_type?: string
  disability_type?: string
  sat_homologo?: string,
  apply_segregation?: boolean
}

export async function getFiscalRules(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = '',
  countryId?: string
): Promise<any> {
  // where's
  const where = ['country_id = :countryId']
  if (search) {
    where.push(`CONCAT(fiscal_rules.name,fiscal_rules.code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN fiscal_rules.code ~ '^[0-9]+$' THEN CAST(fiscal_rules.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, fiscal_rules.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN fiscal_rules.code ~ '^[0-9]+$' THEN CAST(fiscal_rules.code AS NUMERIC) ELSE NULL END), fiscal_rules.code"
      ])
  // result
  const queryMx = [
    `custom_options_1.name AS mxregymetype`,
    `custom_options_2.name AS mxpaymentType`
  ]
  const joinMx = [
    `INNER JOIN custom_options AS custom_options_1  ON custom_options_1.id::varchar = (fiscal_rules.custom_fields->>'custom:mxRegymeType')::varchar`,
    `INNER JOIN custom_options AS custom_options_2 ON custom_options_2.id::varchar = (fiscal_rules.custom_fields->>'custom:mxPaymentType')::varchar`
  ]
  const response: any = await getData({
    tables: ['pg_fiscal_rules'],
    fields: [
      'fiscal_rules.id',
      'fiscal_rules.code',
      'fiscal_rules.name',
      ...(countryId === 'MX' ? queryMx : []),
      'fiscal_rules.updated_at'
    ],
    join: [
      ...(countryId === 'MX' ? joinMx : [])
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getFiscalRule(id: string): Promise<FiscalRule> {
  const data = await getData<any>({
    tables: ['pg_fiscal_rules'],
    fields: [
      'id',
      'code',
      'name',
      'country_id',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createFiscalRule(data: FiscalRule): Promise<boolean> {
  const response: any = await http.post('concept/fiscal-rules', {
    countryId: data.country_id,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateFiscalRule(
  data: FiscalRule,
  id: string
): Promise<boolean> {
  const response: any = await http.put('concept/fiscal-rules/' + id, {
    countryId: data.country_id,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteFiscalRule(id: string): Promise<boolean> {
  const response: any = await http.delete('concept/fiscal-rules/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
